/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'terms': {
    width: 16,
    height: 20,
    viewBox: '0 0 16 20',
    data: '<path pid="0" d="M11.387 0l3.754 3.804v15.41a.79.79 0 0 1-.785.786H.786A.79.79 0 0 1 0 19.215V.785A.79.79 0 0 1 .785 0h10.602zm-1.13.982H.983v18.012h13.153V5.129h-3.877V.982zm-1.059 13.85c.242 0 .439.22.439.49s-.197.492-.439.492H4.113c-.241 0-.438-.221-.438-.491s.197-.49.438-.49zm2.246-3.354c.236 0 .429.221.429.491s-.193.49-.43.49h-7.34c-.235 0-.428-.22-.428-.49s.193-.49.429-.49zm0-3.576c.236 0 .429.22.429.49s-.193.491-.43.491h-7.34c-.235 0-.428-.22-.428-.49s.193-.491.429-.491zm-.205-6.65v2.895h2.847l-2.847-2.895z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/terms.js